(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-header"]) return;
  try {
    
const arteMenuAnimations=new WeakMap();
function setArteMenu(detail,opening){
  const panel=detail.querySelector('.m-nav-panel,.m-mobile-panel'),summary=detail.querySelector('summary'),previous=arteMenuAnimations.get(detail);
  if(!panel||(!detail.open&&!opening))return;
  const start=previous?{opacity:getComputedStyle(panel).opacity,transform:getComputedStyle(panel).transform}:{opacity:opening?0:1,transform:opening?'translateY(-8px) scale(.985)':'translateY(0) scale(1)'};
  previous?.animation.cancel();
  detail.open=true;panel.inert=!opening;summary.setAttribute('aria-expanded',String(opening));
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate){detail.open=opening;panel.inert=false;arteMenuAnimations.delete(detail);return}
  const animation=panel.animate([start,{opacity:opening?1:0,transform:opening?'translateY(0) scale(1)':'translateY(-6px) scale(.99)'}],{duration:opening?260:170,easing:opening?'cubic-bezier(.2,.75,.25,1)':'ease-in',fill:'both'});
  const state={animation,opening};arteMenuAnimations.set(detail,state);
  animation.onfinish=()=>{if(arteMenuAnimations.get(detail)!==state)return;detail.open=opening;panel.inert=false;animation.cancel();arteMenuAnimations.delete(detail)};
}
document.addEventListener('click',event=>{
  const summary=event.target.closest('.m-nav-details>summary,.m-mobile-menu>summary'),detail=summary?.parentElement;
  if(detail){event.preventDefault();const previous=arteMenuAnimations.get(detail);setArteMenu(detail,previous?!previous.opening:!detail.open)}
  document.querySelectorAll('.m-nav-details[open],.m-mobile-menu[open]').forEach(menu=>{if(menu!==detail&&!menu.contains(event.target))setArteMenu(menu,false)});
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.m-nav-details[open],.m-mobile-menu[open]').forEach(detail=>{setArteMenu(detail,false);detail.querySelector('summary').focus()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-product"]) return;
  try {
    
function initMProducts(root=document){root.querySelectorAll('[data-m-product]:not([data-m-ready])').forEach(product=>{product.dataset.mReady='true';const thumbs=[...product.querySelectorAll('[data-m-image]')],panels=[...product.querySelectorAll('[data-m-panel]')],dialog=product.querySelector('.m-zoom');thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));panels.forEach(p=>p.hidden=p.dataset.mPanel!==thumb.dataset.mImage)}));panels.forEach(panel=>panel.addEventListener('click',()=>{const image=panel.querySelector('img');dialog.querySelector('img').src=image.currentSrc||image.src;dialog.querySelector('img').alt=image.alt;dialog.showModal()}));dialog.querySelector('button').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});product.querySelectorAll('.m-overview').forEach(overview=>{
const tabs=[...overview.querySelectorAll('.m-tabs [role=tab]')];
const visuals=[...overview.querySelectorAll('[data-panel-image]')];
const motion=matchMedia('(prefers-reduced-motion:reduce)');
let requested=0;
function revealVisual(id){
 const next=visuals.find(visual=>visual.dataset.panelImage===id);
 if(!next)return;
 const request=++requested;
 const image=next.querySelector('img');
 const reveal=()=>{if(request!==requested)return;visuals.forEach(visual=>visual.classList.toggle('is-current',visual===next))};
 if(image&&!image.complete){image.decode().then(reveal,reveal)}else reveal();
}
function selectTab(tab){
 if(tab.getAttribute('aria-selected')==='true')return;
 const content=overview.querySelector('.v3-photo-content');
 const beforeHeight=content?.getBoundingClientRect().height;
 content?.getAnimations().forEach(animation=>animation.cancel());
 revealVisual(tab.getAttribute('aria-controls'));
 tabs.forEach(t=>{
  const active=t===tab;
  t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;
  const panel=product.querySelector('#'+t.getAttribute('aria-controls'));
  if(!panel)return;
  panel.getAnimations().forEach(animation=>animation.cancel());panel.hidden=!active;
  if(active&&!motion.matches)panel.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:460,easing:'cubic-bezier(.2,.7,.2,1)'});
 });
 if(content&&!motion.matches){const afterHeight=content.getBoundingClientRect().height;if(Math.abs(afterHeight-beforeHeight)>1)content.animate([{height:beforeHeight+'px'},{height:afterHeight+'px'}],{duration:460,easing:'cubic-bezier(.2,.7,.2,1)'})}
}
tabs.forEach((tab,index)=>{
 tab.addEventListener('click',()=>selectTab(tab));
 tab.addEventListener('keydown',event=>{
  let next;
  if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(index+1)%tabs.length;
  if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(index+tabs.length-1)%tabs.length;
  if(event.key==='Home')next=0;
  if(event.key==='End')next=tabs.length-1;
  if(next!==undefined){event.preventDefault();selectTab(tabs[next]);tabs[next].focus()}
 });
})
})})}initMProducts();document.addEventListener('shopify:section:load',event=>initMProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-routine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arte-routine'))customElements.define('arte-routine',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];if(!this.tabs.length)return;
    this.controller=new AbortController();const signal=this.controller.signal;
    this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index),{signal});tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=this.tabs.length-1;if(next!==undefined){event.preventDefault();this.select(next);this.tabs[next].focus()}},{signal})});
    this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-block-id]');const index=this.panels.indexOf(panel);if(index>=0)this.select(index)},{signal});
    this.select(0);this.dataset.ready='true';
    if('IntersectionObserver' in window){this.imageObserver=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.querySelectorAll('img').forEach(image=>{image.loading='eager'});this.imageObserver.disconnect()}},{rootMargin:'250px'});this.imageObserver.observe(this)}
  }
  select(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index})}
  disconnectedCallback(){this.controller?.abort();this.imageObserver?.disconnect();delete this.dataset.ready}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-benefits-bar"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arte-benefits-bar')){
  class ArteBenefitsBar extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.dots=Array.from(this.querySelectorAll('[data-index]'));this.stage=this.querySelector('.v3-benefits__stage');this.toggle=this.querySelector('[data-toggle]');
      if(!this.slides.length)return;
      this.index=Math.max(0,this.slides.findIndex(slide=>!slide.hidden));this.interval=Number(this.dataset.interval)||6000;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=this.dataset.autoplay!=='true'||this.motion.matches;this.hovered=false;this.focused=false;this.visible=true;this.animations=[];
      if(this.slides.length===1){this.setAttribute('data-single','');return}
      this.querySelectorAll('[data-previous],[data-next],.v3-benefits__navigation').forEach(el=>{el.hidden=false});this.dataset.ready='true';
      this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1),options);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),options);
      this.dots.forEach(dot=>dot.addEventListener('click',()=>this.show(Number(dot.dataset.index)),options));
      this.toggle.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.schedule()},options);
      this.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch'){this.hovered=true;this.schedule()}},options);
      this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule()},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},options);
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule()}},options);
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1))}},options);
      this.stage.addEventListener('pointerdown',e=>{this.swipeStart={x:e.clientX,y:e.clientY};this.swiped=false},options);
      this.stage.addEventListener('pointerup',e=>{if(!this.swipeStart)return;const dx=e.clientX-this.swipeStart.x,dy=e.clientY-this.swipeStart.y;this.swipeStart=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){this.swiped=true;this.show(this.index+(dx<0?1:-1))}},options);
      this.stage.addEventListener('pointercancel',()=>{this.swipeStart=null},options);
      this.stage.addEventListener('click',e=>{if(this.swiped){e.preventDefault();this.swiped=false}},{...options,capture:true});
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.userPaused=true;this.schedule()},options);
      document.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(slide=>slide.dataset.blockId===e.detail.blockId);if(index>=0){this.userPaused=true;this.show(index)}},options);
      if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()});this.observer.observe(this)}
      this.schedule();
    }
    show(index){
      const next=(index+this.slides.length)%this.slides.length,moveFocus=this.slides[this.index].contains(document.activeElement);
      this.animations.forEach(animation=>animation.cancel());this.animations=[];
      this.slides.forEach((slide,i)=>{slide.hidden=i!==next;slide.inert=i!==next});
      this.dots.forEach((dot,i)=>{if(i===next)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
      const direction=next===this.index-1||(this.index===0&&next===this.slides.length-1)?-1:1;this.index=next;
      if(!this.motion.matches&&this.slides[next].animate){this.animations.push(this.slides[next].animate([{opacity:0,transform:`translateY(${direction*7}px)`},{opacity:1,transform:'translateY(0)'}],{duration:440,easing:'cubic-bezier(.2,.75,.25,1)'}))}
      if(moveFocus)this.slides[next].querySelector('a')?.focus({preventScroll:true});
      this.schedule();
    }
    schedule(){
      clearTimeout(this.timer);this.dataset.paused=String(this.userPaused);this.toggle.setAttribute('aria-label',this.userPaused?this.dataset.playLabel:this.dataset.pauseLabel);this.stage.setAttribute('aria-live',this.userPaused||this.focused?'polite':'off');
      if(!this.userPaused&&!this.hovered&&!this.focused&&!document.hidden&&this.visible)this.timer=setTimeout(()=>this.show(this.index+1),this.interval);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.animations?.forEach(animation=>animation.cancel())}
  }
  customElements.define('arte-benefits-bar',ArteBenefitsBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-cart-drawer"]) return;
  try {
    
if(!customElements.get('arte-cart-drawer'))customElements.define('arte-cart-drawer',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.events=new AbortController();const signal=this.events.signal;
    document.addEventListener('click',event=>{const trigger=event.target.closest('[data-v3-cart-open]');if(!trigger||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0||!this.dialog.showModal)return;event.preventDefault();this.open(trigger)},{signal});
    this.addEventListener('click',event=>{
      if(event.target.closest('[data-v3-close]'))this.dialog.close();
      const remove=event.target.closest('[data-v3-remove]'),step=event.target.closest('[data-v3-step]');
      if(remove||step){event.preventDefault();const action=remove||step,line=action.closest('[data-key]'),input=line.querySelector('[data-v3-quantity]');this.change(line.dataset.key,remove?0:Number(input.value)+Number(step.dataset.v3Step),action.dataset.focus)}
    },{signal});
    this.addEventListener('change',event=>{if(event.target.matches('[data-v3-quantity]')){const input=event.target;if(input.value.trim()===''||!input.reportValidity())return;this.change(input.closest('[data-key]').dataset.key,Number(input.value),input.dataset.focus)}},{signal});
    this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const box=this.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.dialog.close()},{signal});
    this.dialog.addEventListener('close',()=>{document.body.classList.remove('v3-cart-open');if(this.trigger?.isConnected&&!this.trigger.disabled)this.trigger.focus()},{signal});
    this.updateCount();
  }
  disconnectedCallback(){this.quantityMotion?.cancel();this.events?.abort();document.body.classList.remove('v3-cart-open')}
  status(message,recover=false,state=recover?'error':'pending'){const status=this.querySelector('[data-v3-status]');status.dataset.state=message?state:'idle';status.querySelector('[data-status-text]').textContent=message;status.querySelector('[data-status-check]').toggleAttribute('hidden',state!=='success');this.querySelector('[data-v3-recover]').hidden=!recover}
  lock(value){this.busy=value;this.querySelector('.v3-cart-content').setAttribute('aria-busy',String(value));if(value){this.controls=[...this.querySelectorAll('.v3-cart-content button,.v3-cart-content input')].map(control=>[control,control.disabled]);this.controls.forEach(([control])=>control.disabled=true)}else{this.controls?.forEach(([control,disabled])=>{if(control.isConnected)control.disabled=disabled})}}
  updateCount(){const count=Number(this.querySelector('.v3-cart-content').dataset.count)||0;document.querySelectorAll('[data-v3-cart-count]').forEach(badge=>{badge.textContent=String(count);badge.hidden=count===0});this.querySelectorAll('[data-v3-selection-badge-copy]').forEach(label=>{label.textContent=count===1?label.dataset.singular:label.dataset.plural});document.dispatchEvent(new CustomEvent('arte:cart-updated',{detail:{count}}))}
  renderCart(sections,focus){const html=sections?.[this.dataset.section];if(typeof html!=='string')return false;const parsed=new DOMParser().parseFromString(html,'text/html'),content=parsed.querySelector('.v3-cart-content');if(!content)return false;this.revision=(this.revision||0)+1;const previousProgress=Number(this.querySelector('arte-shipping-progress')?.dataset.percent)||0,nextProgress=content.querySelector('arte-shipping-progress');if(nextProgress){nextProgress.dataset.from=String(previousProgress);nextProgress.dataset.celebrate=String(previousProgress<100&&Number(nextProgress.dataset.percent)>=100)}this.querySelector('.v3-cart-content').replaceWith(content);this.updateCount();if(focus){const target=[...this.querySelectorAll('[data-focus]')].find(node=>node.dataset.focus===focus);if(target&&!target.disabled)target.focus();else this.querySelector('[data-v3-close]').focus()}return true}
  async refresh(focus){const revision=this.revision||0;const url=new URL(location.pathname,location.origin);url.searchParams.set('sections',[this.dataset.section,document.querySelector('[data-cart-section]')?.dataset.cartSection].filter(Boolean).join(','));const response=await fetch(url,{headers:{Accept:'application/json'}});if(!response.ok)throw new Error('cart');const sections=await response.json();if(revision!==(this.revision||0))return false;customElements.get('arte-cart-page')?.renderSections(sections);if(!this.renderCart(sections,focus))throw new Error('section');return true}
  async open(trigger,refresh=false){this.trigger=trigger||document.activeElement;if(!this.dialog.open)this.dialog.showModal();document.body.classList.add('v3-cart-open');this.querySelector('arte-shipping-progress')?.play?.();if(refresh&&!this.busy){const revision=this.revision||0;this.lock(true);this.status(this.dataset.pending);try{if(await this.refresh())this.status('')}catch{if(revision===(this.revision||0))this.status(this.dataset.error,true)}finally{this.lock(false)}}}
 animateQuantity(input,direction){
  this.quantityMotion?.cancel();if(matchMedia('(prefers-reduced-motion:reduce)').matches||!input.animate)return;
  const base=getComputedStyle(input),color=base.color,background=base.backgroundColor,positive=direction>0;
  this.quantityMotion=input.animate([{color:positive?'#29884a':'#b85d58',backgroundColor:positive?'#e4f4dc':'#fae9e7',opacity:.45,transform:'translateY('+(positive?4:-4)+'px) scale(.97)'},{color:positive?'#29884a':'#b85d58',backgroundColor:positive?'#e4f4dc':'#fae9e7',opacity:1,transform:'translateY(0) scale(1.045)',offset:.35},{color,backgroundColor:background,opacity:1,transform:'translateY(0) scale(1)'}],{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'});
 }
  async change(key,quantity,focus){
    if(this.busy||!Number.isSafeInteger(quantity)||quantity<0)return;const oldLine=[...this.querySelectorAll('[data-key]')].find(line=>line.dataset.key===key),oldInput=oldLine?.querySelector('[data-v3-quantity]'),previousQuantity=Number(oldInput?.value)||0,inputFocus=oldInput?.dataset.focus;this.lock(true);this.status(this.dataset.pending);
    try{const response=await fetch(this.dataset.change,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,sections:[this.dataset.section,document.querySelector('[data-cart-section]')?.dataset.cartSection].filter(Boolean),sections_url:location.pathname})});const result=await response.json();if(!response.ok){await this.refresh(focus);this.status(typeof result.description==='string'?result.description:this.dataset.error,true);return}customElements.get('arte-cart-page')?.renderSections(result.sections);if(!this.renderCart(result.sections,focus))await this.refresh(focus);this.status(this.dataset.updated,false,'success');if(quantity>0&&quantity!==previousQuantity){const input=[...this.querySelectorAll('[data-v3-quantity]')].find(el=>el.dataset.focus===inputFocus);if(input)this.animateQuantity(input,quantity-previousQuantity)}}catch{this.status(this.dataset.error,true)}finally{this.lock(false)}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-evidence"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('arte-evidence'))customElements.define('arte-evidence',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;this.tabs=[...this.querySelectorAll('[role=tab]')];this.panels=[...this.querySelectorAll('[role=tabpanel]')];if(!this.tabs.length)return;
    this.controller=new AbortController();const signal=this.controller.signal;
    this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.select(index),{signal});tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=this.tabs.length-1;if(next!==undefined){event.preventDefault();this.select(next);this.tabs[next].focus()}},{signal})});
    this.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-block-id]');const index=this.panels.indexOf(panel);if(index>=0)this.select(index)},{signal});
    this.select(0);this.dataset.ready='true';
  }
  select(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;this.panels[i].hidden=i!==index})}
  disconnectedCallback(){this.controller?.abort();delete this.dataset.ready}
});

  } catch(e) { console.error(e); }
})();
})();
